import { Col, Row } from '@ahmdigital/ui';
import React from 'react';

import {
  changeCoverOptionData,
  extrasOptionData,
  hospitalOptionData,
  myAccountOptionData,
  OptionData,
  somethingElseOptionData,
} from './data';
import { firstRowId } from '../../../branch';
import { FRAGMENTS, SLUG } from '../../../../../../models/table-of-contents/constants';
import ContactOptions, { optionConstantIds } from '../../../contact-options';
import formatContactOptions, { CONTACT_OPTION_ID } from '../utils/format-contact-options';
import QueryType from '../../../query-type';
import RelatedQuestions from '../../../related-questions';
import useGetAllPlaceholders from '../../../../../../components/offers/logic/use-get-all-placeholders';
import useTableOfContents from '../../../../../../cms/utils/use-table-of-contents';

export type CurrentMemberOptionIDs = 'changeCover' | 'extrasAndClaiming' | 'hospital' | 'myAccount' | 'somethingElse';

const mapIDToOptionData: Record<CurrentMemberOptionIDs, OptionData> = {
  changeCover: changeCoverOptionData,
  extrasAndClaiming: extrasOptionData,
  hospital: hospitalOptionData,
  myAccount: myAccountOptionData,
  somethingElse: somethingElseOptionData,
};

type Props = Readonly<{
  id: CurrentMemberOptionIDs;
  showOnlyContactOptions?: boolean;
}>;

const CurrentMember: React.FC<Props> = ({ id, showOnlyContactOptions = false }) => {
  const data = mapIDToOptionData[id];

  const { items, loading: isLoadingTOC } = useTableOfContents({
    fragment: FRAGMENTS.CONTACTS,
    skip: false,
    slug: SLUG.CURRENT_MEMBER_CONTACTS,
  });
  const { loading: isLoadingPlaceholders, placeholders } = useGetAllPlaceholders();

  const isOptionsLoaded = !isLoadingPlaceholders && !isLoadingTOC;

  const contactOptions = formatContactOptions({
    customOptions: [
      {
        contactOptionId: optionConstantIds.memberLogIn,
      },
    ],
    id: CONTACT_OPTION_ID.CURRENT_MEMBER,
    items,
    placeholders,
    title: showOnlyContactOptions ? 'Contact us' : 'Didn’t find what you’re after?',
  });

  return (
    <>
      {!showOnlyContactOptions && (
        <div id={firstRowId}>
          <Row isBoxed>
            <Col df>
              <QueryType {...data.queryType} />
            </Col>
          </Row>
        </div>
      )}
      {!showOnlyContactOptions && (
        <Row isBoxed>
          <Col df>
            <RelatedQuestions {...data.relatedQuestions} />
          </Col>
        </Row>
      )}
      {isOptionsLoaded && (
        <Row isBoxed>
          <Col df>
            <ContactOptions {...contactOptions} showContactUsBanner />
          </Col>
        </Row>
      )}
    </>
  );
};

export default CurrentMember;
